module.exports = __webpack_public_path__ + "media/Audio17_n.01b24491.wav";